var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-login-eagle"},[_c('img',{staticClass:"sw-login-eagle__image-second-flight",attrs:{"src":require("../assets/eagle.png")}})])}]

export { render, staticRenderFns }